/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/define-property.js
// module id = 418
// module chunks = 76